<template>
  <div class="view-tasklists">
    <user-menu />
    <div class="wrapper page_to_up">
      <masteradmin-sidebar-menu v-if="masterAdmin" />
      <div class="content-wrapper">
        <div class="container-wrapper center">
          <div class="modal-custom" v-show="showOverlay">
            <div class="loader-img-center">
              <i class="fa fa-spinner fa-spin"></i> Please wait...
            </div>
          </div>
          
          <div class="form_row">
            <div class="form_col_1">
              <h3 class="d-inline heading">Forms Manager</h3>
            </div>
            <div class="form_col_2">
              <button
                v-on:click="isModalVisible = true, verrors.clear()"
                class="btn btn-red btn-md input-height-15"
                ><i class="fa fa-plus spacer-icon" aria-hidden="true"></i>Form</button>
            </div>
          </div>
          
          <div class="heading-seperator" style="margin-top: 2px;"></div>
          <div class="margin-bottom-10"></div>

          <div class="">
            <b-navbar toggleable="lg" type="light" variant="light">
              <b-navbar-brand href="#">Filter/Search</b-navbar-brand>

              <b-navbar-toggle target="nav-collapse"><i class="fa fa-chevron-down "></i></b-navbar-toggle>


              <b-collapse id="nav-collapse" is-nav>
          <div class="search-wrapper col-12">
          <div class="row col-12 override-padding">
            <div
              class="col-lg-3 col-md-12 col-12"
              >
            <b-form-input
              class="input-text"
              v-model="search_keyword"
              type="text"
              placeholder="Search by Form Name"
              @keyup.enter="filterFormitems()"
              maxlength="255"
            ></b-form-input>
            </div>
            <div class="col-lg-2 col-md-10 col-10">
               <b-form-select
                class="input-text"
                v-model="search_status"
                :options="status_options"
                @change="filterFormitems()"
              >
              </b-form-select>
            </div>
            <div class="col-lg-3 col-md-10 col-10">
               <b-form-select
                class="input-text"
                v-model="search_affiliate"
                :options="affiliate_options"
                @change="filterFormitems()"
              >
              </b-form-select>
            </div>
            <div class="col-lg-2 col-md-12 col-12 padding-lr-5">
               <b-form-select
                class="input-text"
                v-model="search_user"
                :options="user_options"
                @change="filterFormitems()"
              >
              </b-form-select>
            </div>

            <div class="col-lg-1 col-md-2 col-2 search-icon-wrapper cursor-pointer" @click="filterFormitems()">
            <span class="search-icon">
              <i class="fa fa-search"></i>
            </span>
            </div>
            <div class="col-lg-1 col-md-2 col-2 scroll_box cursor-pointer">
              <span class="scroll_up_down" @click="scrollToElement('down')">
                <i class="fa fa-angle-down angle_font"></i>
              </span>
            </div>
          </div>
          </div>
          </b-collapse>
        </b-navbar>
      </div>
          <div class="margin-bottom-10"></div>





          <div>
            <b-card no-body>
              <div class="row tasks_heading_row">
                <div
                  class="bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 text-left"
                  v-on:click="sortMethod('name')"
                  >
                  Form
                  <i v-if="publicSortField == 'name' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                  <i v-if="publicSortField == 'name' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                </div>
                <div
                  class="bold cursor-pointer col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 override-padding text-left"
                  v-on:click="sortMethod('status')"
                  >
                  Status
                  <i v-if="publicSortField == 'status' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                  <i v-if="publicSortField == 'status' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                </div>
                <div
                  class="bold col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding text-center"
                  >
                  # of Fields
                </div>
                <div
                  class="bold col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding text-left"
                  >
                  Affiliate
                </div>
                <div
                  class="bold col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding text-left"
                  >
                  User Type
                </div>
                <div
                  class="bold cursor-pointer col-xl-1 col-lg-1 col-md-1 col-sm-2 col-2 override-padding text-left"
                  v-on:click="sortMethod('createdBy')"
                  >
                  Created By
                  <i v-if="publicSortField == 'createdBy' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                  <i v-if="publicSortField == 'createdBy' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                </div>
                <div
                     class="bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding text-left"
                     v-on:click="sortMethod('updatedAt')"
                     >
                     Last Updated
                     <i v-if="publicSortField == 'updatedAt' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="publicSortField == 'updatedAt' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
              </div>

              <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>


              <b-card-text v-if="formslists.length > 0">
                 <div class="tasklists-row" v-for="(form, index) in formslists" :key="index">
                 <div class="row tasklist-item" style="margin: 0;">
                   <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 text-left">
                     {{form.name}}
                   </div>
                   <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 override-padding text-left">{{ getStatus(form.status) }}</div>
                   <div class="link col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding text-center">
                      {{form.total_assigned_fields }}
                      <button
                          v-on:click="viewFormFields(form.id)"
                          v-if="form.total_assigned_fields > 0"
                          class="btn btn-dark-grey in-use-button override-padding"
                          >View</button>
                   </div>
                   <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 override-padding text-left">{{ form.affiliate_assigned }}</div>
                   <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 override-padding text-left">{{ form.roles_assigned }}</div>
                   <div class="col-xl-1 col-lg-1 col-md-1 col-sm-2 col-2 override-padding text-left">{{ truncate(form.created_by) }}</div>
                   <div class="link col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 override-padding text-center">
                      {{form.updated_at }}
                   </div>
                   <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 override-padding text-left">
                       <div v-bind:id="'dropdown-container-'+ index" class="dropdown" @click="toggleDropdown('actionDropdown_'+index+'')">
                       <ul class="dropbtn icons btn-right showLeft"  v-bind:id="'dotted-menu' + index">
                         <li></li>
                         <li></li>
                         <li></li>
                       </ul>
                       <div v-bind:id="'actionDropdown_' + index" class="dropdown-content">
                         <div v-if="((form.status=='DRAFT' || form.status=='PUBLISH') && (masterAdmin === true) && (!$store.state.switch_admin_username))" class="action-dd-menu" @click="goToEdit(form.id)"><i class="cursor-pointer fa fa-edit spacer-icon"></i>Edit</div>
                         <div v-if="(form.status === 'DRAFT' && (masterAdmin === true) && (!$store.state.switch_admin_username))" class="action-dd-menu" @click="updateFormStatus(form.id, 'PUBLISH')"><i class="cursor-pointer fa fa-upload spacer-icon"></i>Publish</div>
                         <div v-if="((form.status === 'DRAFT' || form.status === 'DEACTIVATED') && (masterAdmin === true) && (!$store.state.switch_admin_username))" class="action-dd-menu" @click="deleteFormConfirm(form.id)"><i class="cursor-pointer fa fa-times spacer-icon"></i>Remove</div>
                         <div v-if="form.status=='PUBLISH'" class="action-dd-menu"  @click="cloneForm(form.id)"><i class="cursor-pointer fa fa-clone spacer-icon"></i>Clone</div>
                         <div v-if="(form.status=='PUBLISH' && (masterAdmin === true) && (!$store.state.switch_admin_username))" class="action-dd-menu"  @click="deactivateFormConfirm(form.id, form.name)"><i class="cursor-pointer fa fa-eye-slash spacer-icon"></i>Deactivate</div>
                         <div v-if="(form.status === 'PUBLISH' && (masterAdmin === true) && (!$store.state.switch_admin_username))" class="action-dd-menu" @click="viewAccount(form.id)"><i class="cursor-pointer fa fa-user-o spacer-icon"></i>View account</div>
                         <div class="action-dd-menu" @click="previewForm(form.id)"><i class="cursor-pointer fa fa-eye spacer-icon"></i>Preview</div>
                         <div class="action-dd-menu" @click="getListOfFormFields(form.id)"><i class="cursor-pointer fa fa-connectdevelop spacer-icon"></i>Map Form fields to PDF</div>
                          <div class="action-dd-menu" v-if="form.status=='DEACTIVATED'" @click="activateFormConfirm(form.id)"><i class="cursor-pointer fa fa-eye-slash spacer-icon"></i>Activate</div>

                       </div>
                       </div>
                   </div>
                 </div>
                 <div><hr></div>
                 </div>
                 <div class="row page_to_down">
                    <div class="mx-auto">
                      <div class="overflow-auto m-3">
                        <b-pagination v-if="rows > 25" 
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        first-text="First"
                        prev-text="Prev"
                        next-text="Next"
                        last-text="Last"
                        v-bind:hide-goto-end-buttons=true
                        @input="showFormsofPaginated()"
                        ></b-pagination>
                      </div>
                    </div>	
                    <div class="page_angle_down">
                      <div class="scroll_box cursor-pointer">
                        <span class="scroll_up_down" @click="scrollToElement('up')">
                          <i class="fa fa-angle-up angle_font"></i>
                        </span>
                      </div>
                    </div>
                  </div>
              </b-card-text>
              <b-card-text v-else-if="loading == false">
                   No Form found.
              </b-card-text>
            </b-card>
          </div>


          <CreateFormModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
            <span v-if="loading" class="pull-right text-danger">
              Loading...
            </span>
            <div slot="header" class="sub-heading"><h3>Create Form</h3></div>
            <div slot="body" v-if="isModalVisible === true">
                <form v-on:submit.prevent="createForm()">
                <div class="col-12 override-padding">
                    <input v-model="form_name"
                        name="form_name"
                        placeholder="Enter Form Name"
                        class="col-lg-12 input-text form-control"
                        style="line-height: 30px "
                        v-validate="'required'"
                        maxlength="255" />
                    <div v-if="verrors.firstByRule('form_name', 'required')" class="margin-bottom-5 validate-warning-msg">Form name is required</div>
                </div>
                <div style="clear: both;" class="margin-bottom-10"></div>

                <div class="col-12 override-padding">
                    <div class="search-padd" id="mentee-group-wrapper">
                        <label class="font-weight-bold">Affilate: </label>
                        <multiselect
                            v-model="affiliate_selected"
                            :options="affiliate_options" track-by="text" label="text"
                            placeholder="Select an Affiliate" :multiple="true"  :close-on-select="false" :show-labels="false"
                            v-validate="'required'"
                            name="affiliate"
                            id="affiliate">
                            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
                        </multiselect>
                        <div v-if="verrors.firstByRule('affiliate', 'required')" class="margin-bottom-5 validate-warning-msg">Affilate is required</div>
                    </div>
                </div>
                <div style="clear: both;" class="margin-bottom-10"></div>
        
                <div class="col-12 override-padding">
                    <div class="search-padd" id="mentee-group-wrapper">
                        <label class="font-weight-bold">Select User Type: </label>
                        <div v-for="(userType, index) in roles_options" :key="index" class="p-1 ml-2">
                            <input type="checkbox"
                            :value="userType.value"
                            v-bind:id="'usertype_'+index"
                            name="usertype"
                            v-model="usertypes_selected"
                            v-validate data-vv-rules="required" data-vv-as="User Type"
                            >
                            <label :for="'usertype_'+index">{{ userType.name }}</label>
                        </div>
                        <div v-if="verrors.firstByRule('usertype', 'required')" class="margin-bottom-5 validate-warning-msg">User Type is required</div>
                    </div>
                </div>
                <div style="clear: both;" class="margin-bottom-10"></div>
                <div class="col-12 override-padding text-align-right">
                    <button
                        type="submit"
                        class="btn btn-primary btn-sm fmAddBtn"
                    ><b>Create</b></button>
                </div>
                </form>
            </div>
            <div slot="footer" class="col-3 override-padding">

            </div>
          </CreateFormModal>

          <ViewFormFieldsListModal :isModalVisible="isFormFieldsListModalVisible" @close="isFormFieldsListModalVisible = false">
            <span v-if="loading" class="pull-right text-danger">
              Loading...
            </span>
            <div slot="header" class="sub-heading">
              <div>Following fields are associated with this form :</div>
              <hr>
              <ul :class="assigned_fields.length > 20 ? 'view-fields-scroll': ''">
                <li v-for="(field, fkey) in assigned_fields" :key="fkey">
                  {{ field.field_name }}
                </li>
              </ul>
            </div>
            <div slot="body">

            </div>
            <div slot="footer" class="col-3 override-padding">

            </div>
          </ViewFormFieldsListModal>

          <DeleteModal :isModalVisible="isDeleteModalVisible" :id="id"  @close="isDeleteModalVisible = false">
            <span v-if="loading" class="pull-right text-danger">
              Loading...
            </span>
            <div slot="header" class="sub-heading">Are you sure you want to delete the form?</div>
            <div slot="body">

            </div>
            <div slot="footer" class="col-3 override-padding">
              <button class="left col-12 btn btn-red" @click="showingdeleteModal = false; deleteForm(id)">Confirm</button>
            </div>
          </DeleteModal>

          <DeactivateModal :isModalVisible="isDeactivateModalVisible" :id="deactivateId"  @close="isDeactivateModalVisible = false">
            <span v-if="loading" class="pull-right text-danger">
              Loading...
            </span>
            <div slot="header" class="sub-heading">Are you sure you want to deactivate? </div>
            <div slot="body">

            </div>
            <div slot="footer" class="col-3 override-padding">
              <button class="left col-12 btn btn-red" @click="showingdeleteModal = false; deactivateForm(deactivateId)">Confirm</button>
            </div>
          </DeactivateModal>

          <ActivateModal :isModalVisible="isActivateModalVisible" :id="activateId"  @close="isActivateModalVisible = false">
            <span v-if="loading" class="pull-right text-danger">
              Loading...
            </span>
            <div slot="header" class="sub-heading">Are you sure you want to Activate? </div>
            <div slot="body">

            </div>
            <div slot="footer" class="col-3 override-padding">
              <button class="left col-12 btn btn-red" @click="activateForm(activateId)">Confirm</button>
            </div>
          </ActivateModal>


      <CheckFormValidationModal :isModalVisible="isDeactivateValidateModalVisible" @close="isDeactivateValidateModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading">This form "{{ formTitle }}" values has been submitted by some users, you can't deactivate this form</div>
        <div slot="body">

        </div>
        <div slot="footer" class="col-3 override-padding">

        </div>
      </CheckFormValidationModal>


          <!-- map form fields pdf modal start -->
          <MapFormFieldsPdfModalVisible :isModalVisible="isMapFormFieldsPdfModalVisible" :id="pdfFormId" @close="closeMapFormFieldsPdfModalVisible()">
              <span v-if="loading" class="pull-right text-danger">
              Loading...
              </span>
              <div slot="header" class="sub-heading"><h3>Map Form fields to PDF:</h3></div>
              <div slot="body" v-if="isMapFormFieldsPdfModalVisible === true">
                  <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving" @submit.prevent="saveFormFieldsToPdf(pdfFormId)">
                      <div class="row p-2" v-for="(field, fIndex) in assigned_fields_with_options.form_fields" :key="fIndex">
                        <div class="col-4">
                            <label>{{ field.field_name }}</label>
                        </div>
                        <div class="col-8" v-if="field.field_type == 'text'">
                          <input v-model="field.pdf_field_name"
                              v-bind:name="'field_pdf_name['+field.field_id+']'"
                              class="col-12 ma-input-field"
                              v-validate="'required'"
                              maxlength="75" />
                        </div>
                        <div style="clear: both;" class="margin-bottom-10"></div>
                        <div class="view_field_options row" v-for="(fieldVal, valIndex) in field.field_values" :key="valIndex">
                          <div class="col-4">
                              <label>{{ fieldVal.optionValue }}</label>
                          </div>
                          <div class="col-8">
                            <input v-model="fieldVal.pdf_field_option_values"
                                v-bind:name="'field_pdf_name['+field.field_id+']['+fieldVal.field_option_value_id+']'"
                                class="col-12 ma-input-field"
                                v-validate="'required'"
                                maxlength="75" />
                          </div>
                          <div v-if="verrors.firstByRule('field_pdf_name['+field.field_id+']['+fieldVal.field_option_value_id+']', 'required')" class="pdf_input_error margin-bottom-5 validate-warning-msg">PDF Field name is required for {{ fieldVal.optionValue }}</div>
                        </div>
                        <div v-if="verrors.firstByRule('field_pdf_name['+field.field_id+']', 'required') && field.field_values.length == 0" class="pdf_input_error margin-bottom-5 validate-warning-msg">PDF Field name is required for {{ field.field_name }} </div>
                      </div>
                      <div style="clear: both;" class="margin-bottom-10"></div>
                      <div class="col-lg-12 col-12 override-padding" v-if="!assigned_fields_with_options.pdf_filename || assigned_fields_with_options.is_pdf_remove">
                        <div class="dropbox">
                          <input 
                            type="file" 
                            name="pdf_file"
                            ref="pdf_file"
                            accept="type/pdf"
                            rules="required"
                            class="input-file">
                            <p v-if="isInitial">Drag your file here to begin<br> or click to browse</p>
                            <p v-if="isSaving"> Uploading file... </p>
                        </div>
                        <p v-if="uploadError" class="text-danger">{{uploadError}}</p>
                      </div>
                      <div class="col-lg-12 col-12 override-padding" v-else>
                        <div class="p-2">Uploaded PDF: 
                          <a :href="assigned_fields_with_options.pdf_full_path" target="_blank">{{ assigned_fields_with_options.pdf_filename}}</a>
                          <a @click="removeExistingPdf()" class="text-danger float-right">
                            <i class="cursor-pointer fa fa-times"></i>
                          </a>
                        </div>
                      </div>
                      
                      <div style="clear: both;" class="margin-bottom-10"></div>
                      <div class="col-12 override-padding text-align-right">
                          <button 
                              type="submit"
                              class="btn btn-primary btn-sm fmAddBtn"
                          ><b>Save</b></button>
                      </div>
                  </form>
              </div>
              <div slot="footer" class="col-3 override-padding">

              </div>
          </MapFormFieldsPdfModalVisible>
          <!-- Map form fields pdf modal end -->

        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import axios from 'axios';
import { store } from '../../store/store';
import CreateFormModal from '../admin/create-tasklist-modal.vue';
import ViewFormFieldsListModal from '../shared/validation_modal_alert.vue';
import router from '../../router/index.js';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import VeeValidate from 'vee-validate';
import Multiselect from 'vue-multiselect';
import DeleteModal from '../shared/delete_modal_alert.vue';
import DeactivateModal from '../shared/delete_modal_alert.vue';
import MapFormFieldsPdfModalVisible from '../admin/map_form_fields_pdf_modal.vue';
import ActivateModal from '../shared/delete_modal_alert.vue';
import CheckFormValidationModal from '../shared/validation_modal_alert.vue';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

export default {
        data() {
          return {
            isModalVisible: false,
            isFormFieldsListModalVisible: false,
            loading: false,
            masterAdmin: false,
            formslists: [],
            rows: 0,
            perPage: 25,
            currentPage: 1,
            publicSortField: 'name',
            publicSortBy: 'ASC',
            editAffiliateName: '',
            editAffiliateStatus: '',
            editAffiliateId: '',
            tasklist_lists: [],
            searchParameters: {
              account: {},
              admin: {},
              sort: {},
              affiliate: {},
              search_mentee: {},
              search_form: {},
            },
            form_name: '',
            affiliate_options: [],
            affiliate_selected: '',
            roles_options: [
              {
                name: 'Manager',
                value: 'ROLE_ADMIN',
              },
              {
                name: 'Mentor',
                value: 'ROLE_MENTOR',
              },
              {
                name: 'Mentee',
                value: 'ROLE_MENTEE',
              },
              {
                name: 'Apprentice',
                value: 'ROLE_APPRENTICE',
              },
            ],
            usertypes_selected: [],
            assigned_fields: [],
            status_options: [
              { value: '', text: 'Status' },
              { value: 'DRAFT', text: 'Draft' },
              { value: 'PUBLISH', text: 'Published' },
              { value: 'DEACTIVATED', text: 'Deactivated' }
            ],
            id: '',
            deactivateId: '',
            activateId: '',
            showOverlay: false,
            isDeactivateModalVisible: false,
            isActivateModalVisible: false,
            isDeleteModalVisible: false,
            isMapFormFieldsPdfModalVisible: false,
            assigned_fields_with_options: [],
            form_fields: {
              pdf_field_name: []
            },
            uploadedFiles: [],
            uploadError: '',
            currentStatus: null,
            pdfFormId: '',
            search_affiliate: '',
            search_status: '',
            filterFlag: false,
            search_user: '',
            user_options: [],
            search_keyword: '',
            isDeactivateValidateModalVisible: false,
            formTitle: '',
          }
        },
        components: {
          UserMenu,
          CreateFormModal,
          ViewFormFieldsListModal,
          MasteradminSidebarMenu,
          Multiselect,
          DeleteModal,
          DeactivateModal,
          ActivateModal,
          CheckFormValidationModal,
          MapFormFieldsPdfModalVisible,
        },
        computed: {
          isInitial() {
            return this.currentStatus === STATUS_INITIAL;
          },
          isSaving() {
            return this.currentStatus === STATUS_SAVING;
          },
          isSuccess() {
            return this.currentStatus === STATUS_SUCCESS;
          },
          isFailed() {
            return this.currentStatus === STATUS_FAILED;
          }
        },
        methods: {
            closeModal() {
              this.$emit('close');
            },
           fetchUserOptions: function() {
             axios.get('/masteradmin-useroptions', {

             })
             .then((response) => {
                 var user_option = {value: '', text: 'Created By'};
                 this.user_options.push(user_option);
                 for(var i=0; i < response.data.length; i++) {
                   var name = response.data[i].first_name + ' ' + response.data[i].last_name;
                   var user_option = {value: response.data[i].id, text: name};
                   this.user_options.push(user_option);
                 }
             })
             .catch(error => {

             });

           },
           fetchAffiliateOptions: function() {
             axios.get('/affiliateoptions', {

             })
             .then((response) => {
                 var affiliate_option = {value: '', text: 'Select Affiliate'};
                 this.affiliate_options.push(affiliate_option);
                 for(var i=0; i < response.data.length; i++) {
                   var affiliate_option = {value: response.data[i].id, text: response.data[i].name};
                   this.affiliate_options.push(affiliate_option);
                 }
             })
             .catch(error => {

             });

           },
            showFormsofPaginated: function() {
              this.fetchFormsManager();
            },
            truncate: function (text) {
              if (text.length > 10) {
                  return text.substring(0, 10) + '...';
              } else {
                  return text;
              }
            },
            getStatus: function(status) {
              var status_val = this.status_options.findIndex(item => item.value === status);
              return this.status_options[status_val].text;
            },
            goToEdit: function(form_id) {
                router.push("/add-form-custom-fields/" + form_id);
            },
            updateFormStatus: function(form_id, status_text) {
              this.showOverlay = true;
              axios('/forms-manager/' + form_id,
               {
                 method: 'PATCH',
                 data: { "status": status_text},
               }
              )
              .then((resp) => {
                this.showOverlay = false;
                this.fetchFormsManager();
              })
              .catch(error => {
                  if(error.response.data.message == 'Access denied.') {
                    router.push("/forbidden");
                  }
              });
            },
            deleteFormConfirm: function(form_id) {
              this.isDeleteModalVisible = true;
              this.id = form_id;
            },
            deleteForm: function(form_id) {
              this.isDeleteModalVisible = false;
              this.showOverlay = true;
              axios('/forms-manager/' + form_id,
                  {
                    method: 'DELETE',
                  }
                )
              .then((resp) => {
                  this.showOverlay = false;
                  this.fetchFormsManager();
                })
              .catch(error => {

              });
            },
            activateFormConfirm(form_id) {
              this.isActivateModalVisible = true;
              this.activateId = form_id;
            },
            activateForm(form_id) {
              this.isActivateModalVisible = false;
              this.showOverlay = true;
              axios('/forms-manager/' + form_id,
                {
                  method: 'PATCH',
                  data: { "status": 'PUBLISH'},
                }
              )
              .then((resp) => {
                this.showOverlay = false;
                this.fetchFormsManager();
              })
              .catch(error => {
                  if(error.response.data.message == 'Access denied.') {
                    router.push("/forbidden");
                  }
              });
            },
            deactivateFormConfirm: function(form_id, form_name) {
              axios('/check-form-assign-count/' + form_id,
                 {
                   method: 'GET',
                 }
               )
              .then((resp) => {
                  if (resp.data.isFormValidation) {
                    this.isDeactivateModalVisible = true;
                    this.deactivateId = form_id;
                  } else {
                    this.isDeactivateValidateModalVisible = true;
                    this.formTitle = form_name;
                  }
               })
              .catch(error => {

              });
            },
            deactivateForm(form_id) {
              this.isDeactivateModalVisible = false;
              this.showOverlay = true;
              axios('/forms-manager/' + form_id,
                {
                  method: 'PATCH',
                  data: { "status": 'DEACTIVATED'},
                }
              )
              .then((resp) => {
                this.showOverlay = false;
                this.fetchFormsManager();
              })
              .catch(error => {
                  if(error.response.data.message == 'Access denied.') {
                    router.push("/forbidden");
                  }
              });
            },
            cloneForm: function(form_id) {
              this.showOverlay = true;
              axios('/clone-form-manager/' + form_id,
                {
                  method: 'POST',
                }
              )
              .then((resp) => {
                this.showOverlay = false;
                store.dispatch('forms_manager', '');
                router.push("/add-form-custom-fields/" + resp.data);
              })
              .catch(error => {
                  if(error.response.data.message == 'Access denied.') {
                    router.push("/forbidden");
                  }
              });
            },
            previewForm: function (form_id) {
              router.push('/display-fill-form/' + form_id);
            },
            viewAccount: function(formId) {
              var ids = [];
              ids.push(formId);
              this.searchParameters.search_form.form_ids = ids;
              store.dispatch('search_parameters', this.searchParameters);
              let routeData = this.$router.resolve({name: 'accountlookupviewlist'});
              window.open(routeData.href, '_blank');
            },
            createForm: function() {
              this.$validator.validateAll().then((result) => {
                if ((this.verrors.items.length === 0)) {
                  axios('/forms-manager',
                     {
                       method: 'POST',
                       data:
                        {
                          name: this.form_name,
                          affiliate_selected: this.affiliate_selected,
                          usertypes_selected: this.usertypes_selected,
                        },
                     }
                   )
                  .then((resp) => {
                    this.flash({ message: 'Form has been created successfully.', variant: 'success' });
                    const form_id = resp.data.id;
                    router.push('/add-form-custom-fields/' + form_id);
                   })
                  .catch(error => {
                    if(error.response.data.message == 'Access denied.') {
                      router.push("/forbidden");
                    }
                    const fieldErrors =  [];
                    var errMsgObj = error.response.data.message;
                    Object.keys(errMsgObj).map(key => {
                      var newFieldErr = {field:key, msg:errMsgObj[key], rule:'exists'};
                      fieldErrors.push(newFieldErr);
                    });
                    this.$validator.errors.add(fieldErrors);
                  });
                }
              })
              .catch(() => {

              });

            },
            viewFormFields: function(formId) {

              const params = { formId: formId }
              axios.get('/form/view-fields', {
                  params: params
              })
              .then((resp) => {
                  this.assigned_fields = resp.data;
                  this.isFormFieldsListModalVisible = true;
              })
              .catch(error => {

              });

            },
            fetchFormsManager: function() {
              this.loading = true;
              if(this.filterFlag) {
                 this.currentPage = 1;
              }
              const params = { _page: this.currentPage }
              if (this.search_keyword) {
                params.name = this.search_keyword
              }
              if (this.search_status) {
                params.status = this.search_status
              }
              if (this.search_user) {
                params.search_user = this.search_user
              }
              if (this.search_affiliate) {
                params.affiliate = this.search_affiliate
              }
              if (this.publicSortField) {
                params.sortfield = this.publicSortField
              }
              if (this.publicSortBy) {
                params.sortby = this.publicSortBy
              }
              axios.get('/forms-manager', {
                  params: params
              })
              .then((resp) => {
                  this.loading = false;
                  this.formslists = resp.data.data;
                  this.currentPage = resp.data.page;
                  this.rows = resp.data.total_rows;
              })
              .catch(error => {

              });
            },
            toggleDropdown (id) {
              document.getElementById(id).classList.toggle("show");
            },
            hideActionMenu(e) {
               var matches = document.getElementsByClassName('dropdown-content');
               for (var i=0; i<matches.length; i++) {
                 var container = document.getElementById('dropdown-container-'+ i);

                 if (!container.contains(e.target)) {
                      if (document.getElementById('actionDropdown_' + i).classList.contains("show")) {
                         document.getElementById('actionDropdown_' + i).classList.remove('show');
                      }
                 }
               }
             },
             sortMethod: function(field) {
               this.publicSortField = field;
               if(this.publicSortBy == 'ASC') {
                 this.publicSortBy = 'DESC';
               }
               else {
                 this.publicSortBy = 'ASC';
               }
               this.fetchFormsManager();
             },
            closeMapFormFieldsPdfModalVisible() {
              this.isMapFormFieldsPdfModalVisible = false;
            },
            filterFormitems: function() {
              this.filterFlag = true;
              this.fetchFormsManager();
            },
            getListOfFormFields(formId) {
              axios.get('/get-assigend-form-fields-with-options/' + formId)
              .then((resp) => {
                this.assigned_fields_with_options = resp.data;
                this.isMapFormFieldsPdfModalVisible = true;
                this.pdfFormId = formId;
              })
              .catch(error => {
              });
            },
            resetUpload() {
              // reset form to initial state
              this.currentStatus = STATUS_INITIAL;
              this.uploadedFiles = [];
              this.uploadError = null;
            },
            saveFormFieldsToPdf(formId) {
              this.$validator.validateAll().then((result) => {
                if ((this.verrors.items.length === 0)) {
                  // handle file changes
                  this.uploadError = '';
                  const pdfData = new FormData();

                  var validateFile = false;
                  if (!this.assigned_fields_with_options.pdf_filename) {
                    validateFile = true;
                  } else {
                    if (!this.assigned_fields_with_options.is_pdf_remove) {
                      validateFile = false;
                    } else {
                      validateFile = true;
                    }
                  }
                  if (validateFile) {
                    if (!this.$refs.pdf_file.files.length) {
                      this.uploadError = 'Upload PDF file'
                      return
                    }

                    if(this.$refs.pdf_file.files[0].type !== "application/pdf") {
                      this.uploadError = 'Upload PDF file only'
                      return
                    }

                    pdfData.append("pdf_file", this.$refs.pdf_file.files[0], this.$refs.pdf_file.files[0].name);
                  }

                  var is_pdf_remove = 0;
                  if (this.assigned_fields_with_options.is_pdf_remove) {
                    is_pdf_remove = 1;
                  }

                  // append the files to FormData
                  pdfData.append("pdf_field_names", JSON.stringify(this.assigned_fields_with_options));
                  pdfData.append("form_id", formId);
                  pdfData.append("is_pdf_remove", is_pdf_remove);
                  pdfData.append("old_pdf_filename", this.assigned_fields_with_options.pdf_filename);
                  
                  // console.log(pdfData)
                  
                  // upload data to the server
                  this.currentStatus = STATUS_SAVING;

                  axios.post('/upload-pdf-form-fields-mapping', pdfData, {
                      headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Accept': 'application/pdf',
                        'Content-Type': 'multipart/form-data'
                      },
                  })
                  .then(resp => {
                    this.flash({ message: "The Pdf file has been uploaded successfully.", variant: 'success' });
                    this.currentStatus = STATUS_SUCCESS;
                    this.isMapFormFieldsPdfModalVisible = false;
                    this.resetUpload();
                    this.fetchFormsManager();
                    this.fetchAffiliateOptions();
                  })
                  .catch(error => {
                    this.uploadError = error.response.data.message;
                    this.currentStatus = STATUS_FAILED;
                  })
                }
              });
            },
            removeExistingPdf() {
              this.assigned_fields_with_options.is_pdf_remove = true;
            },
            scrollToElement(type) {
              const el = this.$el.getElementsByClassName('page_to_'+type)[0];
              if (el) {
                el.scrollIntoView({behavior: 'smooth'});
              }
            }
        },
        mounted() {
           document.addEventListener('click', this.hideActionMenu);
           this.resetUpload();
        },
        beforeDestroy() {
           document.removeEventListener('click', this.hideActionMenu);
        },
        created() {
          var roles = store.state.roles;
          if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
            this.masterAdmin = true;
          }
          this.fetchFormsManager();
          this.fetchAffiliateOptions();
          this.fetchUserOptions();
        },
}
</script>

<style scoped>
.dropdown {
  position: absolute;
  display: inline-block;
  right: 1.4em;
}
.edit-action-btn {
  width: 70px;
  margin-right: 5px;
}
.deactivate-btn {
  width: 83px;
  margin-right: 5px;
}
.preview-wrapper {
  padding-right: 10px;
}
.btn-dark-grey, .btn-dark-grey:hover, .btn-dark-grey:focus {
  background-color: #555;
  color: #FFF;
  border: 1px solid #555;
}
.space-wrapper {
  padding-right: 10px;
}
.tasks_heading_row {
  background-color: #8b8b8b;
  line-height: 30px;
  color: #FFF;
  padding: 3px 0px;
  margin-bottom: 0px;
  margin-right: 0px;
  margin-left: 0px;
}
*, *::before, *::after {
  outline: none;
}
.tasklist-item {
    padding: 12px 0px 12px 0px;
}
hr {
    border-top: 2px solid #8b8b8b;
    margin: 0px;
}
.in-use-button {
  width: 60px;
  margin-left: 5px;
  padding: 2px 0px;
  font-size: 12px;
  border-radius: 46%;
  line-height: 17px;
}
/* code start */
.fmAddBtn {
    color: #FFF;
    background-color: #00acee;
    border: 1px solid #00acee;
    padding: 8px !important;
    font-size: 13px;
    font-weight: 900;
    float: right;
}
.fmAddBtn:focus, .fmAddBtn:active {
    color: #FFF !important;
    background-color: #00acee !important;
    border: 1px solid #00acee !important;
}
.view-fields-scroll {
  height: 300px;
  margin: 0 auto;
  overflow-y: scroll;
}
.view_field_options {
  width: 100%;
  margin: 5px 10px 5px 10px;
}
/* Upload Form CSS Start */
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}
.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}
.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}
.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
/* Upload Form CSS End */
.pdf_input_error  {
  width: 98%;
  text-align: right;
}
input.ma-input-field {
  border-width: 1px;
  border-style: inset;
}  
.form_row { width: 100%; display: flex; flex-wrap: wrap; padding: 0px; }
.form_col_1 { width: 70%; margin-top: 0px; }
.form_col_2 { width: 30%; margin-top: 0px; text-align: right; }
.form_col_3 { width: 10%; text-align: right; }
.scroll_box {
  padding: 0;
  display: flex;
  justify-content: end;
}
.scroll_up_down {
  background-color: #efac91;
  padding: 5px;
  text-align: center;
  width: 40px;
}
.angle_font {
  color: #FFF !important;
  font-size: 1.8rem !important;
}
.page_angle_down { margin: 10px 15px; }
</style>
<style>
.input-height-30 {
  line-height: 28px;
}
#mentee-tasklist-wrapper li span.multiselect__option--selected span::before,
#mentee-group-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#mentee-tasklist-wrapper li span.multiselect__option--selected.multiselect__option--highlight,
#mentee-group-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size:13px;
}
.multiselect__option--selected {
  font-size: 13px;
  font-weight: normal !important;
}
.multiselect, .multiselect__input, .multiselect__single {
  font-size: 13px;
  font-weight: 400;
  color: #707070;
  background-color: #fff !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/admin/forms_manager.vue